export class Price {

    constructor(id: string, value: number = 0, code: string = "CDN", symbol: string = "$"){
        this.id = id
        this.value = value;
        this.currency = code;
        this.symbol = symbol;
    }
    public id: string;
    public value: number = 0;
    public currency: string;
    public symbol: string;
    public fullLabel: string;
    public label: string;

    public static currencyText(price: Price): string {
        return price?.symbol + " " + price?.currency?.toUpperCase();
    }

    public static valueText(price: Price): string {
        return `${price?.value?.toFixed(0)}`;
    }
}